'use client';

import {
  Label as HeroLabel,
  LabelProps as HeroLabelProps,
} from '@heroui/react';
import { ReactNode } from 'react';

export interface LabelProps extends Omit<
  HeroLabelProps,
  'className' | 'style'
> {
  children: ReactNode;
}

export const Label = ({ children, ...props }: LabelProps) => {
  return (
    <HeroLabel
      {...props}
      className="text-sm font-medium text-foreground/70 mb-1"
    >
      {children}
    </HeroLabel>
  );
};
